import { Badge } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { regionForEdit } from '../../../app/services/region/regionSlice';
import { FaTimes } from 'react-icons/fa';

function RegionFormHeader(props) {
  const dispatch = useDispatch();
  const { region } = props;

  return (
    <>
      {region?.id ? (
        <div className="d-flex flex-row justify-content-between">
          {/* Region Status */}
          <div>
            Region <Badge bg={'dark'}>EDIT</Badge>
          </div>
          {/* Cancel Edit Button */}
          <button
            className="btn btn-sm btn-light d-flex gap-1 align-items-center"
            onClick={() => dispatch(regionForEdit({}))}
          >
            <FaTimes /> Abbrechen
          </button>
        </div>
      ) : (
        <div>
          Region <Badge bg={'primary'}>NEW</Badge>
        </div>
      )}
    </>
  );
}

export default RegionFormHeader;
